import React from 'react';
import DetailFreeShipping from '@ali/detail-free-shipping';
import { resetImage } from '@/common/reset-image';
import '@ali/detail-free-shipping/esm/index.less';
import './index.less';


function Index(props: { semiManagedFreeShipping: FreeShippingTypes.Root }) {
  return <DetailFreeShipping {...props} resetImage={resetImage} />;
}

export default Index;
